/**
 * Deterministic PRNG and hash (contracts/sim-api.ts `SimPure.prng` / `hash32`).
 * mulberry32: fast, pure, same seed -> same sequence on every JS engine.
 * Never import Math.random / Date / performance / DOM here
 * (lint rule kn/no-impure-globals enforces this across packages/sim and packages/rules).
 */
/** Small, fast, deterministic 32-bit PRNG. Returns floats in [0, 1). */
export function prng(seed) {
    let a = seed >>> 0;
    return () => {
        a = (a + 0x6d2b79f5) >>> 0;
        let t = a;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
/** Deterministic 32-bit hash of numeric parts (FNV-1a fold + murmur finaliser). */
export function hash32(...parts) {
    let h = 2166136261 >>> 0;
    for (const part of parts) {
        const i = Math.trunc(part);
        const f = Math.floor((Math.abs(part) % 1) * 1e6);
        for (const byte of [
            i & 0xff,
            (i >>> 8) & 0xff,
            (i >>> 16) & 0xff,
            (i >>> 24) & 0xff,
            f & 0xff,
            (f >>> 8) & 0xff,
        ]) {
            h = Math.imul(h ^ byte, 16777619) >>> 0;
        }
    }
    h ^= h >>> 16;
    h = Math.imul(h, 2246822507) >>> 0;
    h ^= h >>> 13;
    h = Math.imul(h, 3266489909) >>> 0;
    h ^= h >>> 16;
    return h >>> 0;
}
